import http from "../../http-common";
/* eslint-disable */
class GaleriFotoService {
  galeriFotoList(page, itemPerPage, beritaId) {
    return http.get(
      "/galeri-foto/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&galeri_id=" +
        beritaId,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("galeri_id", data.galeri_id);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.post("/galeri-foto", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("galeri_id", data.galeri_id);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.put(`/galeri-foto/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/galeri-foto/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new GaleriFotoService();
